import { TransitionComponent } from "./chunk-QUQRJRHE.js";

// src/components/Dialog/Dialog.Panel.tsx
import { Fragment } from "react";
import clsx from "clsx";
import { DialogPanel as HeadlessDialogPanel } from "@headlessui/react";
import { jsx } from "react/jsx-runtime";
var DialogPanel = _ref => {
  let {
    transition = "appear-from-bottom",
    children,
    className
  } = _ref;
  return /* @__PURE__ */jsx(TransitionComponent.Child, {
    variant: transition,
    as: Fragment,
    children: /* @__PURE__ */jsx(HeadlessDialogPanel, {
      className: clsx("pd:dialog__panel", className),
      children
    })
  });
};
var Dialog_Panel_default = DialogPanel;
export { Dialog_Panel_default };